<script>
    import {onMount} from 'svelte';
    import rpcjs from 'rpcjs';
    const {title, goto} = rpcjs.props;
    title.set('Our Moat');
    let blueDiv;
    let points = '0vw';
    /**
     */
    function onStart() {
        blueDiv.style.opacity = '0';
    }
    onMount(onMountFunction);
    /**
     */
    function onMountFunction() {
        setTimeout(onStart, 10);
    }
    /**
     * Adds two numbers together.
     */
    function next() {
        blueDiv.style.opacity = '100%';
        points = '100vw';
        setTimeout(() => {
            goto('/ourTeam');
        }, 500);
    }
    /**
     * Adds two numbers together.
     * @param {int} e The first number.
     */
    function keycheck(e) {
        e.preventDefault();
        if (e.key == 'ArrowRight') {
            next();
        }
        if (e.key == 'ArrowLeft') {
            goto('/roadmap');
        }
    }
</script>

<svelte:window on:keyup={keycheck}/>

<section role="presentation" on:click={next}>
<div class="bluediv" bind:this={blueDiv}>
</div>
    <div class="main-div">
        <div class="background">
            <div class="img-wrapper">
                <img
                src="../images/moat/the_pass_of_cirena_by_shabazik_ddxuslj1.png"
                alt=""
                width="100%"
                height="100%"
                class='img'
            />
            </div>
            
            <div class="moat">
                <p>OUR<br>MOAT</p>
            </div>
            <div class="points" style="left:{points}">
                <div class="heading">
                    <p>Data Silos</p>
                </div>
                <div class="heading" style="margin: 6.019vh 0; width:65.729vw;">
                    <p>Proprietary Technology</p>
                </div>
                <div class="heading" style="width: 79.740vw;">
                    <p>Streaming-tech with thin-client</p>
                </div>
            </div>
        </div>
    </div>
</section>

<style>
    section{
        position: relative;
    }
    .img-wrapper{
        width: 100vw;
        height: 100vh;
    }
    .img{
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: top;
    }
    .bluediv{
        position: absolute;
        width: 100%;
        overflow: hidden;
        height: 100vh;
        opacity: 100%;
        transition-duration: 0.5s;
        background-color: #02080D;
        z-index: 1;
    }
    .main-div {
        position: relative;
        width: 100%;
        overflow: hidden;
        height: 100vh;
        background-color: #CECECF;
    }
    .background {
        width: 100%;
    }
    p{
        margin: 0;
    }
    .moat {
        position: absolute;
        top: 18.796vh;
        left: 13.981vh;
        text-align: left;
    }
    .moat p {
        font-family: "Montserrat";
        font-weight: 900;
        font-size: 18.519vh;
        color: #ff007f;
        line-height: 13.963vh;
    }
    .points {
        position: absolute;
        text-align: left;
        top: 50.889vh;
        overflow: hidden;
        padding-top: 3vh;
        transition-duration: 0.5s;
        animation: svelte-16egs76-in 3s;
    }
    @keyframes in {
        0% {
            left: -100vh;
        }
        100% {
            left: 0vh;
        }
    }
    .heading{
        width: 35.938vw;
        background-color: #FDFDFD;
        height: 4.630vh;
    }
    .heading p{
        font-family: 'Montserrat';
        font-weight: 900;
        font-size: 3.125vw;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        color: #000000;
        top: -3vh;
        padding-left: 8.333vw;
        position: relative;
    }
</style>
